module.exports = __webpack_public_path__ + "media/images/products-f1b0a5e5db7c51170d65f67e49432bd8.png";